'use strict'

import axios from "axios";

if( !axios.defaults.headers.common.Authorization) {
    axios.defaults.headers.common = {
        "Authorization": "Basic " + localStorage.getItem( 'authbearer' ),
        "Content-Type": "application/json"
    };
}

export default {
    getWorkers: (state ) => {
        return new Promise( done => {
            axios.get( `/api/workers/list/` )
                .then( res => {
                    if( res.data && res.data.success ){
                        state.commit( 'setWorkers', res.data.data );
                    }
                    done( res.data.data )
                } )
                .catch( err => done( err ) )
        } )
    },
    setPause: ( state, data ) => {
        return new Promise( done => {
            axios.put( '/api/workers/pause/', data )
                .then( res => {
                    done( res.data )
                } )
                .catch( err => done( err ) )
        } )
    },
    setWorkerSandboxed: ( state, data ) => {
        return new Promise( done => {
            axios.put( '/api/workers/sandbox/', data )
                .then( res => {
                    done( res.data )
                } )
                .catch( err => done( err ) )
        } )
    },
    deleteWorker: (state, data) => {
        return new Promise( done => {
            axios.delete( '/api/workers/delete/' + data.id )
                .then( res => done( res.data ) )
                .catch( err => done( err ) )
        } )
    },
}